import api from './axiosClient'
import {
    HeatmapConfiguration,
    HeatmapSecuritiesRequest,
    HeatmapSecuritiesResponse,
    HeatmapGroupBy,
} from '../../proto/generated/screener'

// Re-export types so components can import from one place
export type { HeatmapConfiguration, HeatmapSecuritiesRequest, HeatmapSecuritiesResponse }
export { HeatmapGroupBy }

export const getHeatmapConfiguration = async (): Promise<HeatmapConfiguration> => {
    return new Promise((resolve, reject) => {
        api.get('/screener/heatmap-configuration', {
            headers: { Accept: 'application/x-protobuf' },
            responseType: 'arraybuffer',
        }).then((response) => {
            const decoded = HeatmapConfiguration.decode(new Uint8Array(response.data))
            if (!decoded.supportedSectors) decoded.supportedSectors = []
            resolve(decoded)
        }).catch(reject)
    })
}

export const getHeatmapSecurities = async (
    request: HeatmapSecuritiesRequest
): Promise<HeatmapSecuritiesResponse> => {
    return new Promise((resolve, reject) => {
        api.post('/screener/heatmap-securities', JSON.stringify(request), {
            headers: { Accept: 'application/x-protobuf' },
            responseType: 'arraybuffer',
        }).then((response) => {
            const decoded = HeatmapSecuritiesResponse.decode(new Uint8Array(response.data))
            resolve(decoded)
        }).catch(reject)
    })
}
